var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-container",
      class: [_vm.expanded == true ? "expanded" : ""],
      on: {
        click: function($event) {
          return _vm.expandCart(false)
        }
      }
    },
    [
      _vm.expanded == false
        ? _c(
            "div",
            {
              staticClass: "unexpanded-cart",
              on: {
                touchstart: _vm.dragStart,
                touchend: _vm.dragEnd,
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "product-preview-container" }, [
                _c(
                  "div",
                  { staticClass: "products-container" },
                  [
                    _vm._l(_vm.selectedAddonProducts, function(addonProduct) {
                      return _c(
                        "div",
                        {
                          key: addonProduct.variants[0].id,
                          staticClass: "addon-container"
                        },
                        [
                          _vm.isExtendedBoxes &&
                          _vm.extendedProducts.includes(addonProduct.title) &&
                          _vm.step == 2
                            ? _c("div", { staticClass: "alert-overlay" }, [
                                _c("img", {
                                  staticClass: "alert-icon",
                                  attrs: {
                                    src:
                                      "https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886"
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "main-image",
                            attrs: { src: _vm.getProductImage(addonProduct) }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "floating-qty" }, [
                            _vm._v(_vm._s(addonProduct.quantity))
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.selectedBoxProduct
                      ? _c("div", { staticClass: "addon-container" }, [
                          _c("img", {
                            staticClass: "main-image",
                            attrs: {
                              src: _vm.getProductImage(_vm.selectedBoxProduct)
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedCardProduct
                      ? _c("div", { staticClass: "addon-container" }, [
                          _c("img", {
                            staticClass: "main-image",
                            attrs: {
                              src: _vm.getProductImage(_vm.selectedCardProduct)
                            }
                          })
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "happybox-button white border",
                    on: {
                      click: function($event) {
                        return _vm.expandCart(true)
                      }
                    }
                  },
                  [_vm._v("Preview box")]
                ),
                _vm._v(" "),
                _vm.step != 3
                  ? _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        on: {
                          click: function($event) {
                            return _vm.changePage(true)
                          }
                        }
                      },
                      [_vm._v("Next >")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        class: _vm.isloading ? "isLoading" : "",
                        on: {
                          click: function($event) {
                            return _vm.next()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.isloading ? "loading..." : "Next >"))]
                    )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "expanded-cart",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "expanded-cart-header",
              on: { touchstart: _vm.dragStart, touchend: _vm.dragEnd }
            },
            [
              _c(
                "p",
                {
                  staticClass: "close-alert",
                  on: {
                    click: function($event) {
                      return _vm.expandCart(false)
                    }
                  }
                },
                [_vm._v("< Keep Shopping")]
              ),
              _vm._v(" "),
              _vm.isEditingName == false
                ? _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content: _vm.boxAlert,
                            show: _vm.showBoxAlert,
                            trigger: ["manual"]
                          },
                          expression:
                            "{content: boxAlert, show: showBoxAlert, trigger: ['manual']}"
                        }
                      ],
                      staticClass: "box-name"
                    },
                    [_vm._v(_vm._s(_vm.boxName))]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEditingName
                ? _c(
                    "button",
                    {
                      staticClass: "box-name-legend",
                      on: {
                        click: function($event) {
                          return _vm.editName(true)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/icon.png?v=1658429893"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditingName
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.boxName,
                        expression: "boxName"
                      }
                    ],
                    attrs: { type: "text", maxlength: "34" },
                    domProps: { value: _vm.boxName },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.editName(false)
                      },
                      blur: function($event) {
                        return _vm.checkName()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.boxName = $event.target.value
                      }
                    }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "product-summary-container no-scrollbar" },
            [
              _c("div", { staticClass: "product-summary" }, [
                _c("p", { staticClass: "summary-title" }, [
                  _vm._v("Box Contents")
                ]),
                _vm._v(" "),
                _vm.productQtyCopy
                  ? _c("p", { staticClass: "summary-text" }, [
                      _vm._v(_vm._s(_vm.productQtyCopy))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "products-container" },
                  [
                    _vm._l(_vm.selectedAddonProducts, function(addonProduct) {
                      return _c("li", { key: addonProduct.variants[0].id }, [
                        _c("div", { staticClass: "addon-container" }, [
                          _c("div", { staticClass: "image-container" }, [
                            _c("img", {
                              staticClass: "main-image",
                              attrs: { src: _vm.getProductImage(addonProduct) },
                              on: {
                                click: function($event) {
                                  return _vm.openModalProduct(addonProduct)
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-information" }, [
                            _c("div", [
                              _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(addonProduct.title))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "product-data-container" },
                              [
                                _c("p", { staticClass: "price" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("moneyFormat")(addonProduct))
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "product-qty-container" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: addonProduct.quantity,
                                            expression: "addonProduct.quantity"
                                          }
                                        ],
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                addonProduct,
                                                "quantity",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function($event) {
                                              return _vm.changeOnDemand(
                                                addonProduct
                                              )
                                            }
                                          ]
                                        }
                                      },
                                      _vm._l(
                                        _vm.addonMaxQty(addonProduct),
                                        function(qty) {
                                          return _c(
                                            "option",
                                            {
                                              key: qty,
                                              domProps: { value: qty }
                                            },
                                            [_vm._v(_vm._s(qty))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "delete-button",
                                      attrs: {
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeProduct(addonProduct)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _vm.selectedBoxProduct
                      ? _c("li", [
                          _c("div", { staticClass: "addon-container" }, [
                            _c("div", { staticClass: "image-container" }, [
                              _c("img", {
                                staticClass: "main-image",
                                attrs: {
                                  src: _vm.getProductImage(
                                    _vm.selectedBoxProduct
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-information" }, [
                              _c("div", [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.selectedBoxProduct.title))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "product-data-container" },
                                [
                                  _c("p", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moneyFormat")(
                                          _vm.selectedBoxProduct
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedCardProduct
                      ? _c("li", [
                          _c("div", { staticClass: "addon-container" }, [
                            _c("div", { staticClass: "image-container" }, [
                              _c("img", {
                                staticClass: "main-image",
                                attrs: {
                                  src: _vm.getProductImage(
                                    _vm.selectedCardProduct
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-information" }, [
                              _c("div", [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.selectedCardProduct.title))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "product-data-container" },
                                [
                                  _c("p", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moneyFormat")(
                                          _vm.selectedCardProduct
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "remove-all",
                    on: {
                      click: function($event) {
                        return _vm.removeAll()
                      }
                    }
                  },
                  [_vm._v("Remove All")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box-container" }, [
                _c("div", { staticClass: "box-qty-container" }, [
                  _c("p", [_vm._v("Box Quantity")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-qty-input-container" }, [
                    _c(
                      "button",
                      {
                        attrs: { disabled: _vm.selectedBoxQty == 1 },
                        on: {
                          click: function($event) {
                            return _vm.incrementBoxQty(false)
                          }
                        }
                      },
                      [_vm._v("-")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedBoxQty,
                          expression: "selectedBoxQty"
                        }
                      ],
                      attrs: { type: "number", min: "1" },
                      domProps: { value: _vm.selectedBoxQty },
                      on: {
                        blur: function($event) {
                          return _vm.changeBoxQty(null)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.selectedBoxQty = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.incrementBoxQty(true)
                          }
                        }
                      },
                      [_vm._v("+")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "multiship-notice" }, [
                  _vm._v(
                    "Adjust the quantity if you'd like duplicates of this box, even if you're shipping to different addresses!"
                  )
                ]),
                _vm._v(" "),
                _vm.customAlert
                  ? _c("p", { staticClass: "custom-notice" }, [
                      _vm._v(_vm._s(_vm.customAlert))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-container" }, [
                _c("div", { staticClass: "item-summary" }, [
                  _c("p", { staticClass: "item-title" }, [
                    _vm._v("Box Summary")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-total" }, [
                    _c("div", { staticClass: "total-container" }, [
                      _vm.boxQty > 1
                        ? _c("p", { staticClass: "title" }, [
                            _c("strong", [
                              _vm._v("(" + _vm._s(_vm.boxQty) + ")")
                            ]),
                            _vm._v(" " + _vm._s(_vm.boxName))
                          ])
                        : _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.boxName))
                          ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneySaleFormat")(
                              _vm.totalPrice * _vm.boxQty
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "individual-price" }, [
                      _vm._v(
                        _vm._s(_vm._f("moneySaleFormat")(_vm.totalPrice)) +
                          " per box"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-total" }, [
                    _c("div", { staticClass: "total-container" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Gift Box Design "),
                        _vm.step == 1
                          ? _c("span", [_vm._v("(selected at next step)")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.selectedBoxProduct
                        ? _c("p", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moneySaleFormat")(
                                  _vm.boxPrice * _vm.boxQty
                                )
                              )
                            )
                          ])
                        : _c("p", { staticClass: "price" }, [_vm._v("$--")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-total" }, [
                    _c("div", { staticClass: "total-container" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Card "),
                        _vm.step == 2
                          ? _c("span", [_vm._v("(selected at future step)")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.selectedCardProduct
                        ? _c("p", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moneySaleFormat")(
                                  _vm.cardPrice * _vm.boxQty
                                )
                              )
                            )
                          ])
                        : _c("p", { staticClass: "price" }, [_vm._v("$--")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-total" }, [
                    _c("div", { staticClass: "total-container" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Handpacking Fee")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneySaleFormat")(_vm.feePrice * _vm.boxQty)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.hasOnDemandProducts
                      ? _c("p", { staticClass: "purple-legend" }, [
                          _vm._v(
                            " Some items in your cart may  require 1-2 week lead time.  But trust us, they're worth the wait!"
                          )
                        ])
                      : _vm.hasCustomProducts
                      ? _c("p", { staticClass: "individual-price" }, [
                          _vm._v(
                            "Custom items require a lead time of at least 1-2 weeks. Our team will reach out via email to coordinate shipping details."
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-total" }, [
                    _c("p", { staticClass: "title" }, [_vm._v("Item Total")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "price" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moneySaleFormat")(_vm.totalPrice * _vm.boxQty)
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "separator" }),
                _vm._v(" "),
                _c("div", { staticClass: "subtotal-container" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("Estimated Subtotal")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "price" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("moneySaleFormat")(_vm.totalPrice * _vm.boxQty)
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(1)
              ]),
              _vm._v(" "),
              _vm.recommendedAddons.length > 0
                ? _c("div", { staticClass: "recommendation-container" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Perfect fit for your box")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "recommended-addon-container no-scrollbar"
                      },
                      _vm._l(_vm.recommendedAddons, function(addon) {
                        return _c(
                          "div",
                          { key: addon.id, staticClass: "recommended-addon" },
                          [
                            _c("img", {
                              staticClass: "main-image",
                              attrs: { src: addon.image.src },
                              on: {
                                click: function($event) {
                                  return _vm.openModalProduct(addon)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "happybox-button white border",
                                on: {
                                  click: function($event) {
                                    return _vm.updateReccomendedAddonProductQuantity(
                                      addon
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.addCopy))]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "addon-title" }, [
                              _vm._v(_vm._s(addon.title))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "price" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moneySaleFormat")(
                                    addon.variants[0].price
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "VueSlickCarousel",
                {
                  attrs: {
                    infinite: true,
                    dots: true,
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "prevArrow",
                      fn: function(arrowOption) {
                        return [
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648"
                              }
                            })
                          ])
                        ]
                      }
                    },
                    {
                      key: "nextArrow",
                      fn: function(arrowOption) {
                        return [
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648"
                              }
                            })
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _vm.hasOnDemandProducts
                    ? _c("div", { staticClass: "notice-container" }, [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/box.svg?v=1658459692"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("Items may take up to ~2 weeks to ship")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "subtitle" }, [
                            _vm._v("All boxes are made to order, "),
                            _c("br"),
                            _vm._v(" just for you!")
                          ])
                        ])
                      ])
                    : _c("div", { staticClass: "notice-container" }, [
                        _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/box.svg?v=1658459692"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("We hand-pack your items!")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "subtitle" }, [
                            _vm._v("Our team will ensure your box "),
                            _c("br"),
                            _vm._v(" feels full and is packed perfectly!")
                          ])
                        ])
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "notice-container" }, [
                    _c("img", {
                      staticClass: "main-image",
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/boxwings.svg?v=1658459692"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Multiple addresses? No problem!")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "subtitle" }, [
                        _vm._v("Ship to one or many locations all "),
                        _c("br"),
                        _vm._v(" in one, easy checkout")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            target: "_blank",
                            href:
                              "https://www.loom.com/share/d6c4740fe5534425a14581d913b91910?sid=672876ae-7e19-49bd-b06a-b75f17df94ac"
                          }
                        },
                        [_vm._v("Watch the Demo")]
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "complete-box" }, [
            _vm.step != 3
              ? _c(
                  "button",
                  {
                    staticClass: "happybox-button green border",
                    on: {
                      click: function($event) {
                        return _vm.changePage(true)
                      }
                    }
                  },
                  [_vm._v("Next >")]
                )
              : _c(
                  "button",
                  {
                    staticClass: "happybox-button green border",
                    class: _vm.isloading ? "isLoading" : "",
                    on: {
                      click: function($event) {
                        return _vm.bundle()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.isloading ? "loading..." : "Continue to Cart")
                    )
                  ]
                )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "taxes-container" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Taxes "),
        _c("strong", [_vm._v("(calculated in checkout)")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "price" }, [_vm._v("--")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "multiship-block" }, [
      _c("p", [_c("strong", [_vm._v("Shipping to multiple addresses?")])]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_Shipping_Template.xlsx?v=1679594143",
              download: "",
              target: "_blank"
            }
          },
          [_vm._v("Click")]
        ),
        _vm._v(" to download our bulk shipping "),
        _c("br"),
        _vm._v(" template to upload at checkout!")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }